module.exports = __webpack_public_path__ + "img/free-samples.4655a78c.svg";